import { useCallback, useEffect, useRef, useState } from "react";

export function useDelayedHover<T>(delay = 50) {
  const [activeValue, setActiveValue] = useState<T | null>(null);
  const timerRef = useRef<number | null>(null);

	const clearTimer = useCallback(() => {
    if (timerRef.current === null) {
      return;
    }

    window.clearTimeout(timerRef.current);
		timerRef.current = null;
	}, []);

	const clearHover = () => {
    clearTimer();
    setActiveValue(null);
  };

  const startHover = (value: T) => {
    clearTimer();

    if (delay <= 0) {
      setActiveValue(value);
      return;
    }

    timerRef.current = window.setTimeout(() => {
      setActiveValue(value);
      timerRef.current = null;
    }, delay);
  };

  const endHover = (value?: T) => {
    clearTimer();

    if (value === undefined) {
      setActiveValue(null);
      return;
    }

    setActiveValue((current) => (Object.is(current, value) ? null : current));
  };

	useEffect(() => clearTimer, [clearTimer]);

  return {
    activeValue,
    clearHover,
    endHover,
    startHover,
  };
}
